import React, { useState, useEffect } from "react";
import Leftbar from "../../components/Leftsidebar";
import Topbar from "../../components/Topbar";
import { Link } from "react-router-dom";
import "../Projects/project.css";
import { handleNewDealsList, usTimezone } from '../Utils/utils';
import ReactPaginate from 'react-paginate';
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';
import Loaderspinner from "../../components/Loader";
import { Tooltip } from 'react-tooltip'

const Newdeals = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [typeStatus, setTypeStatus] = useState("");
  const [projectList, setProjectList] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false)
  const [projectScope, setProjectScope] = useState("")
  const [amount, setAmount] = useState(0)

  const handleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleSidebarClose = () => {
    setShowSidebar(false);
  };

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        setLoading(true)
        const token = localStorage.getItem("token");
        const limit = 10;
        const offset = page * limit;

        const response = await handleNewDealsList({
          type: typeStatus,
          project_scope: projectScope,
          amount: amount,
          sortBy: "created_at",
          order: "desc",
          limit,
          offset,
          token,
        });

        setProjectList(response?.data?.data || []);

        if ((response?.data?.data.length || 0) < limit) {
          setTotalPages(page + 1);
        } else {
          setTotalPages(page + 2);
        }

      } catch (error) {
        console.error("Error fetching lenders:", error);
      } finally {
        setLoading(false)
      }
    };

    fetchProjects();
  }, [typeStatus, projectScope, amount, page]);


  return (
    <>
      {loading && <Loaderspinner />}
      <div class="g-sidenav-show  bg-gray-100">
        <div id="wrapper">
          <Leftbar showSidebar={showSidebar}
            handleSidebarClose={handleSidebarClose} />
          <main className="main-content border-radius-lg">
            <Topbar handleSidebar={handleSidebar} />

            <div className="header header-bg pb-6">
              <div className="container-fluid">
                <div className="header-body">
                  <div className="row align-items-center py-4">
                    <div className="col-lg-6 col-7">
                      <nav
                        aria-label="breadcrumb"
                        className="d-none d-md-inline-block ml-md-4"
                      >
                        <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                          <li className="breadcrumb-item">
                            <Link to="/dashboard">
                              <i className="fas fa-home" />
                            </Link>
                          </li>
                          <li className="breadcrumb-item mt-2">
                            <span className="" style={{ color: "#f6f9fc" }}>New Deals</span>
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid mt--6">
              <div className="row">
                <div className="col">
                  <div className="card">
                    <div className="card-header border-0">
                      <div className="d-flex justify-content-between">
                        <div className="row ">
                          <h5 className="mb-0 w-auto">New Deals</h5>
                          <p
                            className="w-auto px-0"
                            data-tooltip-id="my-tooltip"
                            data-tooltip-content="Displays projects that have been posted within the last 7 days. Use this to track fresh opportunities and prioritize engagement with newly added projects."
                            data-tooltip-place="top"
                          >
                            <i className="fas fa-info-circle" />

                          </p>

                          <Tooltip id="my-tooltip" style={{ width: '30%' }} />
                        </div>
                        <div className="d-flex">
                          <div className="mx-2">
                            <select
                              className="custom-select-dropdown font-bold"
                              value={typeStatus}
                              onChange={(e) => setTypeStatus(e.target.value)}
                            >
                              <option value="" className='option'>Funding Type</option>
                              <option value="SeekingCapital" className='option'>Seeking Capital</option>
                              <option value="FixAndFlip" className='option'>Fix & Flip</option>
                            </select>
                          </div>
                          <div className="mx-1">
                            <select
                              className="custom-select-dropdown font-bold"
                              value={projectScope}
                              onChange={(e) => setProjectScope(e.target.value)}
                            >
                              <option value="" className='option'>Project Scope</option>
                              <option value="SingleFamily" className='option'>Single Family</option>
                              <option value="MultiFamily" className='option'>Multi Family</option>
                              <option value="LandDeal" className='option'>Land Deal</option>
                              <option value="Commercial" className='option'>Commercial</option>
                            </select>
                          </div>
                          <div className="mx-1">
                            <select
                              className="custom-select-dropdown font-bold"
                              value={amount}
                              onChange={(e) => setAmount(e.target.value)}
                            >
                              <option value="" className='option'>Amount</option>
                              <option value="50000" className='option'>Less than 50,000</option>
                              <option value="100000" className='option'>Up to 100,000</option>
                              <option value="200000" className='option'>Up to 200,000</option>
                              <option value="300000" className='option'>Up to 300,000</option>
                              <option value="400000" className='option'>Up to 400,000</option>
                              <option value="500000" className='option'>Up to 500,000</option>
                              <option value="600000" className='option'>Up to 600,000</option>
                              <option value="700000" className='option'>Up to 700,000</option>
                              <option value="800000" className='option'>Up to 800,000</option>
                              <option value="900000" className='option'>Up to 900,000</option>
                              <option value="1000000" className='option'>Up to 1,000,000</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="table align-items-center table-flush">
                        <thead className="thead-light">
                          <tr>
                            <th>Action</th>
                            <th>Project Name</th>
                            <th>Project Type</th>
                            <th>Created At</th>
                            <th>Project Scope</th>
                            <th>Location</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {projectList?.length > 0 ? (
                            projectList.map((project, index) => (
                              <tr key={index}>
                                <td>
                                  <div style={{ width: "120px" }}>
                                    <Link to={`/view-project/${project?.id}`} target="_blank">
                                      <button className="viewproject-btn pull-right mb-1">
                                        <span className="text-white">View Project</span>
                                      </button>
                                    </Link>
                                  </div>
                                </td>

                                <td className="table-user">
                                  <div className="row w-100">
                                    <span className="w-auto">{project?.project_name}</span>

                                  </div>
                                </td>

                                <td className="table-user">
                                  <div>
                                    <span>{project?.type}</span>
                                  </div>
                                </td>

                                <td className="table-user">
                                  <div style={{ width: "120px" }}><span>{usTimezone(project?.created_at)}</span></div>
                                </td>

                                <td className="table-user">
                                  {project?.project_scope}
                                </td>

                                <td className="table-user">
                                  <div>
                                    <div className="">{project?.location ? project?.location : " "} {project?.city} </div>
                                  </div>
                                </td>

                                <td className="table-user">
                                  <div>
                                    <div className="">{project?.needed} </div>
                                  </div>
                                </td>

                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="10" className="text-center"><b>No records found</b></td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <Row>
                <Col xs={12}>
                  <div className='paginate-css'>
                    <ReactPaginate
                      previousLabel="<"
                      nextLabel=">"
                      breakLabel="..."
                      pageCount={totalPages}
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={2}
                      onPageChange={({ selected }) => setPage(selected)}
                      containerClassName="pagination"
                      activeClassName="active"
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </main>
        </div>
      </div>
    </>

  )
}
export default Newdeals;